import React from 'react';

import './LoadingSpinner.css';

export const LoadingSpinner = ({ size = 'large' }) => {
  const height = size === 'small' ? '12px' : '64px';
  const top = size === 'small' ? '2px' : '27px';
  const circleSize = size === 'small' ? '8px' : '11px';
  const divStyle = { top, height: circleSize, width: circleSize };
  return (
    <div className="lds-ellipsis" role="progressbar" style={{ height }}>
      <div style={divStyle}></div>
      <div style={divStyle}></div>
      <div style={divStyle}></div>
      <div style={divStyle}></div>
    </div>
  );
};

/*
export const LoadingSpinner2 = () => {
  return(<div className="loadingSpinner"><div className="spinner spinner__2"></div></div>
)}
*/
